import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ZoomMinusIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 13, 13);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M3.5 6.16667H6.16667H8.83333M12.5 12.5L10.1667 10.1667M11.8333 6.16667C11.8333 9.29628 9.29628 11.8333 6.16667 11.8333C3.03705 11.8333 0.5 9.29628 0.5 6.16667C0.5 3.03705 3.03705 0.5 6.16667 0.5C9.29628 0.5 11.8333 3.03705 11.8333 6.16667Z"
        stroke="#70707D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ZoomMinusIcon;